module.exports = __webpack_public_path__ + "static/media/event_not_found.ef33c7bb.png";